// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#282c34","secondaryColor":"#61dafb","author":"Author_author__uHcoe"};